import Wrapper from '../Wrapper/Wrapper';
import React from 'react';
import PropTypes from 'prop-types';

const QuoteText = ({ isDesktop }) => (
  <Wrapper
    font={'"Avenir", "Arial", sans-serif'}
    fontSize={isDesktop ? '30px' : '15px'}
    margin="0 22px 0 22px"
    textAlign="center"
    fontWeight="900"
    lineHeight={isDesktop ? '41px' : '20px'}
    fontStyle="italic"
  >
    "If you're a fan of Italian fashion brands but find that getting your hands on them can be a logistical nightmare,
    you're going to love www.italist.com. This luxury site is here to make your shopping dreams come true!"
  </Wrapper>
);

QuoteText.defaultProps = {
  isDesktop: false
};

QuoteText.propTypes = {
  isDesktop: PropTypes.bool
};

export default QuoteText;
